import React from 'react';
import ReportCard from "../../../../../components/reports/report-card.jsx";

const CardsContent = ({ data }) => {
    const cards = data?.cards;

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3">
                    <ReportCard title="Protegidos" value={cards.citizens ?? 0}/>
                    <ReportCard title="Ações de acompanhamento" value={cards.monitoring_actions ?? 0}/>
                    <ReportCard title="Eventos de SOS" value={cards.sos_events ?? 0}/>
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;